$(function() {
    // Global ScrollTrigger Configuration
    // This file should be loaded before any component-specific ScrollTrigger usage
    // Provides centralized configuration for all ScrollTrigger instances

    function initGlobalScrollTriggerConfig() {
        // Check if GSAP is available
        if (typeof gsap === 'undefined') {
            console.warn('GSAP not found. ScrollTrigger configuration will not work.');
            return;
        }

        // Check if ScrollTrigger is available
        if (typeof ScrollTrigger === 'undefined') {
            console.warn('ScrollTrigger not found. Make sure ScrollTrigger is loaded before this script.');
            return;
        }

        // Register ScrollTrigger plugin globally
        gsap.registerPlugin(ScrollTrigger);

        // Set global ScrollTrigger configuration
        ScrollTrigger.config({
            // Ignore mobile resize events to prevent unnecessary recalculations
            ignoreMobileResize: true,
            
            // Optional: Set sync interval for better performance (default is 200ms)
            syncInterval: 9999999,
            
            // Optional: Limit callbacks for better performance
            limitCallbacks: true,
            
            // Optional: Configure auto refresh events
            autoRefreshEvents: "DOMContentLoaded,load,resize"
        });

		// Enable ScrollTrigger.normalizeScroll for smooth scrolling
		ScrollTrigger.normalizeScroll(false);
		
		// Track the current state of normalize scroll
		window.scrollTriggerNormalizeEnabled = false;

        // Global ScrollTrigger defaults that can be overridden by individual components
       

        
        // Expose global refresh function
        window.refreshAllScrollTriggers = function() {
            ScrollTrigger.refresh();
        };

        // Expose global kill all function
        window.killAllScrollTriggers = function() {
            ScrollTrigger.killAll();
        };
        
        // Expose functions to control ScrollTrigger.normalizeScroll
        window.disableScrollTriggerNormalize = function() {
            if (window.scrollTriggerNormalizeEnabled) {
                ScrollTrigger.normalizeScroll(false);
                window.scrollTriggerNormalizeEnabled = false;
            }
        };
        
        window.enableScrollTriggerNormalize = function() {
            if (!window.scrollTriggerNormalizeEnabled) {
                ScrollTrigger.normalizeScroll(true);
                window.scrollTriggerNormalizeEnabled = true;
            }
        };

        // Handle window resize with debouncing
        let resizeTimer;
        window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
                if (!ScrollTrigger.isTouch || window.innerWidth !== window.outerWidth) {
                    ScrollTrigger.refresh();
                }
            }, 250);
        });
    }

    // Function to detect if page is in edit mode
    function isEditMode() {
        // Check for editor path
        const isEditorPath = top.location.pathname.includes('/editor.html');
        
        if (isEditorPath) {
            return 'AUTHOR';
        }
        return 'PUBLISH';
    }

    // Initialize on document ready
    $(document).ready(function() {
        // Skip ScrollTrigger initialization if in edit mode
        if (isEditMode() === 'AUTHOR') {
            return;
        }
        
        // Initialize ScrollTrigger configuration
        initGlobalScrollTriggerConfig();
    });
}); 